import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { INNER_BOTTOM_SPACE_DESK, colorsPalette } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        '&:first-child': {
          marginTop: 76,
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
          '&:first-child': {
            marginTop: 120,
          },
        },
      },
      container: {
        paddingRight: 0,

        '& .swiper-container::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          right: -1,
          width: 50,
          height: 314,
          background: `transparent linear-gradient(-90deg, ${theme.palette.secondary.dark} 0%, #2D323800 100%) 0% 0% no-repeat padding-box`,
          zIndex: 3,
        },

        [theme.breakpoints.up('sm')]: {
          paddingRight: 16,

          '& .swiper-container::after': {
            // Hide for now shadow on desktop
            opacity: 0,
            height: 369,
            background: `transparent linear-gradient(-90deg, ${
              background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light
            } 0%, #2D323800 100%) 0% 0% no-repeat padding-box`,
          },
        },
        [theme.breakpoints.up('md')]: {
          paddingRight: 24,
        },
        [theme.breakpoints.up('xl')]: {
          paddingRight: 16,
        },
      },
      heading: {
        marginBottom: 22,
        [theme.breakpoints.up('sm')]: {
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      sliderWrapper: {
        marginBottom: 40,
        [theme.breakpoints.up('sm')]: {
          marginTop: 0,
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
        '& .swiper-container': {
          overflow: 'visible',
        },
      },
      newsItem: {
        display: 'flex',
        flexDirection: 'column',
        background:
          background === 'Dark' ? theme.palette.secondary.light : theme.palette.secondary.dark,
        boxShadow: `0px 3px 5px ${colorsPalette.black}`,
        borderRadius: 5,
        boxSizing: 'border-box',
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
          '& img.preview': {
            width: '110%',
          },
        },
      },
      imageWrap: {
        width: '100%',
        height: 126,
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '5px 5px 0 0',

        '& img': {
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          transition: 'width .3s ease',
        },

        [theme.breakpoints.up('sm')]: {
          height: 153,
        },
      },
      image: {
        width: '100%',
        height: 126,
        overflow: 'hidden',
        objectFit: 'cover',
        background: colorsPalette.black,
        [theme.breakpoints.up('sm')]: {
          height: 153,
        },
      },
      roundImageWrapper: {
        position: 'absolute',
        marginTop: 100,
        marginLeft: 18,
        width: 52,
        height: 52,
        border: `3px solid ${theme.palette.secondary.light}`,
        background: `${theme.palette.secondary.light}`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto',
        overflow: 'hidden',
        zIndex: 3,

        '& img': {
          height: '100%',
          borderRadius: '40%',
          objectFit: 'cover',
        },

        [theme.breakpoints.up('sm')]: {
          marginTop: 120,
          marginLeft: 22,
          width: 63,
          height: 63,
        },
      },
      textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginTop: 10,
        height: 178,
        padding: 18,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          marginTop: 0,
          height: 216,
          padding: 22,
        },
      },
      title: {
        marginTop: 10,
        maxWidth: 1000,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        fontSize: 20,
        [theme.breakpoints.up('sm')]: {
          marginTop: 18,
        },
      },
      subTitle: {
        marginTop: 12,
        fontSize: 16,
        maxWidth: 1000,
        color: colorsPalette.gray,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        [theme.breakpoints.up('sm')]: {
          marginTop: 16,
          fontSize: 16,
          lineHeight: 1.5,
        },
      },
      dateTitle: {
        marginTop: 9,
        maxWidth: 1000,
        color: colorsPalette.violet,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        fontFamily: '"sofia-pro", sans-serif',
        fontSize: 12,
        [theme.breakpoints.up('sm')]: {
          fontSize: 14,
          lineHeight: 1.5,
          marginTop: 0,
        },
      },
      btnWrap: {
        display: 'flex',
        justifyContent: 'center',
      },
      lazyAvatarWrapper: {
        width: '100%',
        height: '100%',
      },
    }),
  );
export default useStyles;
